<template>
  <div class="w100 pl20 pr20 pt20 pb20 flex-box showcase-config-page" v-loading="loading">
    <div class="left-menu">
      <div class="module-tree-box">
        <div class="menu-title">选择模块</div>
        <div class="module-tree pb20">
          <el-tree
            :data="moduleTree"
            :props="defaultProps"
            @node-click="handleNodeClick"
            default-expand-all
            :expand-on-click-node="false"
          ></el-tree>
        </div>
      </div>
      <div class="module-block-box">
        <div class="menu-title">
          子模块
          <el-tooltip
            class="right-icon"
            effect="light"
            content="Bottom Center 提示文字"
            placement="bottom"
          >
            <i class="el-icon-question"></i>
            <div slot="content" style="width: 100%">
              <div
                style="
                  color: #49a4f0;
                  text-align: center;
                  width: 100%;
                  padding-bottom: 10px;
                "
              >
                提示
              </div>
              <div style="text-align: center; color: #4b4b4b">
                拖动模块或点击添加到右边容器显示
              </div>
            </div>
          </el-tooltip>
        </div>
        <div style="height: 10px"></div>
        <!-- 子模块 -->
        <component
          :ref="activeModule.component+'C'"
          :is="activeModule.component+'C'"
          :childModules="childModules"
          :homeModules="homeModules"
          @addClick="addClick"
        />
      </div>
    </div>
    <div class="right-content flex-1">
      <div class="right-head">
        <!-- {{showcaseConfigData.deskName}} -->
        <el-button
          type="primary"
          style="position: absolute; top: 0; right: 10px"
          size="medium"
          @click="saveConfig"
          :disabled="saving"
          :loading="saving"
          >保存</el-button
        >
        <!-- <el-button
          style="position: absolute; top: 0; right: 10px"
          size="medium"
          @click="closeShowcaseConfig"
          >返回</el-button
        > -->
      </div>

      <component
        :ref="activeModule.component"
        :is="activeModule.component"
        :childModules="childModules"
        @selectedChange="selectedChange"
        @caseChanged="caseChanged"
      />
    </div>
  </div>
</template>

<script>
import card from '@/components/management/showcase/card'
import subject from '@/components/management/showcase/subject'
import subjectdl from '@/components/management/showcase/subjectdl'
import topic from '@/components/management/showcase/topic'
import topicdl from '@/components/management/showcase/topicdl'
import tinfoLink from '@/components/management/showcase/tinfoLink'
import home from '@/components/management/showcase/home'
import linkMaga from '@/components/management/showcase/linkMaga'
import linkMagaC from '@/components/management/showcase/childModules/linkMagaC'
import homeC from '@/components/management/showcase/childModules/homeC'
import tinfoLinkC from '@/components/management/showcase/childModules/tinfoLinkC'
import cardC from '@/components/management/showcase/childModules/cardC'
import topicC from '@/components/management/showcase/childModules/topicC'
import subjectC from '@/components/management/showcase/childModules/subjectC'
import SchoolDateC from '@/components/management/showcase/childModules/SchoolDate'
import draggable from "vuedraggable";
import {getNavigationList, getTopicCatalogList, getSubjectCatalogList, savePageDeskVo, getServeCommentList, getCalendar} from '@/api/management/showcase'
import {tableList, getNoticeList} from '@/api/portrayal/policy'
import request from '@/util/http'
import { mapGetters, mapActions } from "vuex";

export default {
  name: "showcaseConfig",
  components: { draggable, card, subject, subjectdl, topic,topicdl, tinfoLink, home, homeC, tinfoLinkC, cardC, topicC, subjectC, SchoolDateC, linkMaga, linkMagaC },
  props: ['showcaseConfigData'],
  data() {
    return {
      loading: false,
      moduleTree: [
        {
          label: "首页",
          component: "home",
          code: 'HOME',
          children: [
            {
              label: "卡片",
              component: "card",
              code: 'CARD',
            },
            // {
            //   label: "主题",
            //   component: "subject",
            //   code: 'SUBJECT',
            // },
            {
              label: "专题",
              component: "topic",
              code: 'TOPIC',
            },
            {
              label: "信息导航",
              component: "tinfoLink",
              code: 'LINK',
            },
              {
                  label: "信息发布管理",
                  component: "linkMaga",
                  code: 'LINKMAGA',
              },
          ],
        },
      ],
      defaultProps: {
        children: "children",
        label: "label",
      },
      childModules: [],
      activeModule: {
        component: "home",
      },
      navigationList: [],
      topicCatalogList: [],
      subjectCatalogList: [],
      fileList: [],//校内公文
        rulesList: [],//规章制度
        businessList: [],//业务流程
        downloadList: [],//常用下载
      noticeList: [], //通知公告
      CalendarList: {}, //校历周数据
      nodeList: {},  //便签数据
        schList: {},  //日程数据
        affairList: {},  //事务数据
      ServeCommentData: {},
      changed: false,
      homeModules: [],
      saving: false,
    };
  },
  created() {
    this.getChildModules();
    this.getLaunchData();
    // this.getCalendarList()
  },
  computed: {
    ...mapGetters(['moduleList']),
  },
  watch: {

  },
  methods: {
    closeShowcaseConfig(){
      if(this.changed){
        this.$confirm('是否确认放弃修改并关闭页面?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          this.$emit('closeShowcaseConfig')
        })
      }else {
        this.$emit('closeShowcaseConfig')
      }
    },
    handleNodeClick(e) {
      const included = this.moduleList.some((item) => {
        return item.cardType === e.code
      })
      if(!included && e.code!=='HOME'){
        this.$alert(`没有添加${e.label}模块,若要编辑该模块请先添加至首页`, '提示')
        return
      }
      if(this.changed && e.component !== this.activeModule.component){
        this.$confirm('当前页面尚未保存,切换页面会丢失修改的数据,是否确定继续切换页面?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.homeModules = JSON.parse(JSON.stringify(this.moduleList))  // 还原修改
          this.changed = false;
          this.activeModule = e;
          this.getChildModules();
        })
      }else {
        this.activeModule = e;
        this.getChildModules();
      }
    },
    getChildModules() {
      if(this.activeModule.component==='home'){
        this.childModules = [
          { id: 1, name: "卡片", code: 'CARD' },
          { id: 2, name: "主题", code: 'SUBJECT' },
          { id: 3, name: "专题", code: 'TOPIC' },
          { id: 4, name: "服务评价", code: 'COMMENT' },
          { id: 5, name: "信息导航", code: 'LINK' },
          { id: 6, name: "信息发布管理", code: 'LINKMAGA' },
          { id: 7, name: "应用中心", code: 'SUBJECTDL' },
          { id: 8, name: "办事服务", code: 'TOPICDL' },
        ]
      }else if(this.activeModule.component==='tinfoLink'){
        this.childModules = this.navigationList;
      }else if(this.activeModule.component==='card'){
        this.childModules = [
          {
            "title": "通知公告",
            "code": "TINFO_NOTICE",
            "type": "LIST",
            "pos": 0,
            "len": 5,
            "data": this.noticeList,
            "col": 1,
            "row": 1,
            "dataConfig": ""
          },
          {
            "title": "校内公文",
            "code": "TINFO_POLICY_FILE",
            "type": "LIST",
            "pos": 0,
            "len": 5,
            "data": this.fileList,
            "col": 1,
            "row": 1,
            "dataConfig": ""
          },
            {
                "title": "校历",
                "code": "TINFO_CALENDAR",
                "type": "LIST",
                "pos": 0,
                "len": 8,
                "data": this.CalendarList,
                "col": 1,
                "row": 1,
                "dataConfig": ""
            },
            {
                "title": "便签",
                "code": "TINFO_LABLE",
                "type": "LIST",
                "pos": 0,
                "len": 8,
                "data": this.nodeList,
                "col": 1,
                "row": 1,
                "dataConfig": ""
            },
            {
                "title": "日程",
                "code": "TINFO_SCHEDULE",
                "type": "LIST",
                "pos": 0,
                "len": 8,
                "data": this.schList,
                "col": 1,
                "row": 1,
                "dataConfig": ""
            },
            {
                "title": "我的事务",
                "code": "TINFO_AFFAIR",
                "type": "LIST",
                "pos": 0,
                "len": 8,
                "data": this.affairList,
                "col": 1,
                "row": 1,
                "dataConfig": ""
            }
        ]
      }else if(this.activeModule.component==='topic'){
        this.childModules = this.topicCatalogList;
      }else if(this.activeModule.component==='subject'){
        this.childModules = this.subjectCatalogList;
      }else if(this.activeModule.component==='linkMaga'){
          this.childModules = [
              {
                  "title": "规章制度",
                  "code": "TINFO_RULES",
                  "type": "LIST",
                  "pos": 0,
                  "len": 5,
                  "data": [],
                  "col": 3,
                  "row": 1,
                  "dataConfig": ""
              },
              {
                  "title": "业务流程",
                  "code": "TINFO_BUSINESS",
                  "type": "LIST",
                  "pos": 0,
                  "len": 5,
                  "data": [],
                  "col": 3,
                  "row": 1,
                  "dataConfig": ""
              },
              {
                  "title": "常用下载",
                  "code": "TINFO_DOWNLOAD",
                  "type": "LIST",
                  "pos": 0,
                  "len": 5,
                  "data": [],
                  "col": 3,
                  "row": 1,
                  "dataConfig": ""
              }
          ]
      } else {
        this.childModules = []
      }
    },
    getNavigationList(){
      return getNavigationList({len:100,pos:0})
    },
    getTopicCatalogList(){
      return getTopicCatalogList({len:100,pos:0})
    },
    getSubjectCatalogList(){
      return getSubjectCatalogList({len:100,pos:0})
    },
    getServeCommentList(){
      return getServeCommentList()
    },
      //获取校历周
    // getCalendarList(){
    //     getCalendar().then(({data}) =>{
    //         this.CalendarList = data.data
    //     })
    // },
    getTableList(){
      return tableList({current:1,size:5})
    },
    getNoticeList(){
      return getNoticeList({pos:0,len:5})
    },
      //各模块接口
    getLaunchData(){
      this.loading = true;
      request.all([this.getNavigationList(), this.getTopicCatalogList(), this.getSubjectCatalogList(), this.getServeCommentList(), this.getTableList(), this.getNoticeList()])
      .then((res) => {
        res.forEach((item, index) => {
          if(item.data.code !== 0){
            this.$message.error(item.data.msg);
          }else {
            switch (index) {
              case 0:
                this.navigationList = item.data.data;
                break;
              case 1:
                this.topicCatalogList = item.data.data;
                break;
              case 2:
                this.subjectCatalogList = item.data.data;
                break;
              case 3:
                this.ServeCommentData = item.data.data;
                break;
              case 4:
                let arr = []
                item.data.data.records.forEach((item) => {
                  let data = {}
                  data.fiDate = item.createTime.substring(item.createTime.indexOf('-')+1,item.createTime.indexOf(' '))
                  data.fiTitle = item.title;
                  data.fiId = item.id
                  arr.push(data)
                })
                this.fileList = arr;
                break;
              case 5:
                this.noticeList = item.data.data;
                break;
            }
          }
        });
      }).finally(() => {
        this.loading = false
      })
    },
    selectedChange(data){
      switch (data.module) {
        case 'home':
          let arr = [];
          data.data.forEach(item => {
            const exist = this.moduleList.some((element) => {
              return element.cardType === item.code
            })
            if(exist){
              this.moduleList.forEach(element => {
                if(element.cardType===item.code){
                  arr.push(JSON.parse(JSON.stringify(element)))
                }
              });
            }else {
              let newItem = {};
              switch (item.code) {
                case 'CARD':
                  newItem = {
                    "cardType": "CARD",
                    "cardCol": 2,
                    "cardRow": 1,
                    "dataConfig": null,
                    "cardModules": [
                      {
                        "title": "通知公告",
                        "code": "TINFO_NOTICE",
                        "type": "LIST",
                        "pos": 0,
                        "len": 8,
                        "data": this.noticeList,
                        "col": 1,
                        "row": 1,
                        "dataConfig": ""
                      },
                      {
                        "title": "校内公文",
                        "code": "TINFO_POLICY_FILE",
                        "type": "LIST",
                        "pos": 0,
                        "len": 8,
                        "data": this.fileList,
                        "col": 1,
                        "row": 1,
                        "dataConfig": ""
                      },
                      {
                          "title": "校历",
                          "code": "TINFO_CALENDAR",
                          "type": "LIST",
                          "pos": 0,
                          "len": 8,
                          "data": this.CalendarList,
                          "col": 1,
                          "row": 1,
                          "dataConfig": ""
                      },
                      {
                          "title": "便签",
                          "code": "TINFO_LABLE",
                          "type": "LIST",
                          "pos": 0,
                          "len": 8,
                          "data": this.nodeList,
                          "col": 1,
                          "row": 1,
                          "dataConfig": ""
                      },
                      {
                          "title": "日程",
                          "code": "TINFO_SCHEDULE",
                          "type": "LIST",
                          "pos": 0,
                          "len": 8,
                          "data": this.schList,
                          "col": 1,
                          "row": 1,
                          "dataConfig": ""
                      },
                      {
                          "title": "我的事务",
                          "code": "TINFO_AFFAIR",
                          "type": "LIST",
                          "pos": 0,
                          "len": 8,
                          "data": this.affairList,
                          "col": 1,
                          "row": 1,
                          "dataConfig": ""
                      }
                    ]
                  }
                  break;
                case 'SUBJECT':
                  newItem = {
                    "cardType": "SUBJECT",
                    "cardCol": 1,
                    "cardRow": 1,
                    "dataConfig": null,
                    "cardModules": [
                      {
                        "title": "主题分类模块",
                        "code": "TSER_SUBJECT",
                        "type": "LIST",
                        "pos": 0,
                        "len": 8,
                        "data": this.subjectCatalogList,
                        "col": 1,
                        "row": 1,
                        "dataConfig": ""
                      },
                    ]
                  }
                  break;
                case 'SUBJECTDL':
                    newItem = {
                        "cardType": "SUBJECTDL",
                        "cardCol": 1,
                        "cardRow": 1,
                        "dataConfig": null,
                        "cardModules": [
                            {
                                "title": "应用中心",
                                "code": "TSER_SUBJECTDL",
                                "type": "LIST",
                                "pos": 0,
                                "len": 8,
                                "data": this.subjectCatalogList,
                                "col": 1,
                                "row": 1,
                                "dataConfig": ""
                            },
                        ]
                    }
                  break;
                case 'TOPIC':
                  newItem = {
                    "cardType": "TOPIC",
                    "cardCol": 1,
                    "cardRow": 1,
                    "dataConfig": null,
                    "cardModules": [
                      {
                        "title": "专题分类模块",
                        "code": "TSER_TOPIC",
                        "type": "LIST",
                        "pos": 0,
                        "len": 8,
                        "data": this.topicCatalogList,
                        "col": 4,
                        "row": 1,
                        "dataConfig": ""
                      }
                    ]
                  }
                  break;
                case 'TOPICDL':
                    newItem = {
                        "cardType": "TOPICDL",
                        "cardCol": 1,
                        "cardRow": 1,
                        "dataConfig": null,
                        "cardModules": [
                            {
                                "title": "办事服务",
                                "code": "TSER_TOPICDL",
                                "type": "LIST",
                                "pos": 0,
                                "len": 8,
                                "data": this.topicCatalogList,
                                "col": 4,
                                "row": 1,
                                "dataConfig": ""
                            }
                        ]
                    }
                  break;
                case 'COMMENT':
                  newItem = {
                    "cardType": "COMMENT",
                    "cardCol": 1,
                    "cardRow": 1,
                    "dataConfig": null,
                    "cardModules": [
                      {
                        "title": "服务评价模块",
                        "code": "TSER_COMMENT",
                        "type": "DETAIL",
                        "pos": 0,
                        "len": 8,
                        "data": this.ServeCommentData,
                        "col": 1,
                        "row": 1,
                        "dataConfig": ""
                      }
                    ]
                  }
                  break;
                case 'LINK':
                  newItem = {
                    "cardType": "LINK",
                    "cardCol": 1,
                    "cardRow": 1,
                    "dataConfig": null,
                    "cardModules": [
                      {
                        "title": "信息导航模块",
                        "code": "TINFO_LINK",
                        "type": "LIST",
                        "pos": 0,
                        "len": 8,
                        "data": this.navigationList,
                        "col": 5,
                        "row": 1,
                        "dataConfig": ""
                      }
                    ]
                  }
                  break;
                  case 'LINKMAGA':
                  newItem = {
                          "cardType": "LINKMAGA",
                          "cardCol": 3,
                          "cardRow": 1,
                          "dataConfig": null,
                          "cardModules": [
                              {
                                  "title": "规章制度",
                                  "code": "TINFO_RULES",
                                  "type": "LIST",
                                  "pos": 0,
                                  "len": 5,
                                  "data": [],
                                  "col": 3,
                                  "row": 1,
                                  "dataConfig": ""
                              },
                              {
                                  "title": "业务流程",
                                  "code": "TINFO_BUSINESS",
                                  "type": "LIST",
                                  "pos": 0,
                                  "len": 5,
                                  "data": [],
                                  "col": 3,
                                  "row": 1,
                                  "dataConfig": ""
                              },
                              {
                                  "title": "常用下载",
                                  "code": "TINFO_DOWNLOAD",
                                  "type": "LIST",
                                  "pos": 0,
                                  "len": 5,
                                  "data": [],
                                  "col": 3,
                                  "row": 1,
                                  "dataConfig": ""
                              }
                          ]
                      }
                  break;
              }
              arr.push(newItem)
            }
          });
          this.homeModules = arr;
          // this.$store.commit('setModuleList', arr)
          break;
        case 'card':
          const carIindex = this.homeModules.findIndex((item) => {
            return item.cardType === 'CARD'
          })
          if(carIindex > -1){
            this.homeModules[carIindex].cardModules = data.data;
            this.homeModules[carIindex].cardCol = data.col;
            this.$set(this.homeModules, carIindex, this.homeModules[carIindex])
          }
          break;
        case 'linkMaga':
              const linkMagaIindex = this.homeModules.findIndex((item) => {
                  return item.cardType === 'LINKMAGA'
              })
              if(linkMagaIindex > -1){
                  this.homeModules[linkMagaIindex].cardModules = data.data;
                  this.homeModules[linkMagaIindex].cardCol = data.col;
                  this.$set(this.homeModules, linkMagaIindex, this.homeModules[linkMagaIindex])
              }
              break;
        case 'topic':
          const topicIndex = this.homeModules.findIndex((item) => {
            return item.cardType === 'TOPIC'
          })
          if(topicIndex > -1){
            this.homeModules[topicIndex].cardModules[0].data = data.data;
            this.homeModules[topicIndex].cardModules[0].col = data.col;
            this.$set(this.homeModules, topicIndex, this.homeModules[topicIndex])
          }
          break;
        case 'topicdl':
              const topicdlIndex = this.homeModules.findIndex((item) => {
                  return item.cardType === 'TOPICDL'
              })
              if(topicIndex > -1){
                  this.homeModules[topicdlIndex].cardModules[0].data = data.data;
                  this.homeModules[topicdlIndex].cardModules[0].col = data.col;
                  this.$set(this.homeModules, topicdlIndex, this.homeModules[topicdlIndex])
              }
              break;
        case 'subjectdl':
              const subjectdlIndex = this.homeModules.findIndex((item) => {
                  return item.cardType === 'SUBJECTDL'
              })
              if(subjectdlIndex > -1){
                  this.homeModules[subjectdlIndex].cardModules[0].data = data.data;
                  this.homeModules[subjectdlIndex].cardModules[0].col = data.col;
                  this.$set(this.homeModules, subjectdlIndex, this.homeModules[subjectdlIndex])
              }
              break;
        case 'tinfoLink':
          const linkIndex = this.homeModules.findIndex((item) => {
            return item.cardType === 'LINK'
          })
          if(linkIndex > -1){
            this.homeModules[linkIndex].cardModules[0].data = data.data;
            this.homeModules[linkIndex].cardModules[0].col = data.col;
            this.$set(this.homeModules, linkIndex, this.homeModules[linkIndex])
          }
          break;
      }
    },
    saveConfig(){
      // 判断子模块不能为空
      const isEmpty = this.$refs[this.activeModule.component].isEmpty()
      if(isEmpty){
        this.$message.warning('子模块不能为空')
        return
      }
      let obj = {
        cards: this.homeModules,
        deskDes: null,
        deskId: this.showcaseConfigData.deskId || '',
        deskType: this.showcaseConfigData.deskType,
      }
      this.saving = true
      savePageDeskVo(obj)
      .then(({data}) => {
        if(data.code==0){
          this.$message.success('保存成功')
          if(this.showcaseConfigData.deskId){
            this.$store.dispatch("getPageDeskVo", this.showcaseConfigData.deskId)
          }
          this.changed = false;
        }else {
          this.$message.error(data.msg)
        }
      }).finally(() => {
        this.saving = false
      })
    },
    addClick(data){
      this.$refs[this.activeModule.component].addButton(data)
    },
    caseChanged(bol){
      this.changed = bol;
    },
  },
};
</script>

<style lang="less" >
@import "./showcaseConfig.less";
</style>
